// 首页页面接口
import axios from '@/utils/http'
import Url from './requestUrl'

// 查看是否是最新版本
export function getAppNewVersion (params) {
  return axios({
    url: Url.getAppNewVersionUrl,
    method: 'get',
    params
  })
}

// 用户的审批信息
export function getAuditList () {
  return axios({
    url: Url.getAuditListUrl,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/http/home.js